    
    
    <div class="element-values-section">
        <div class="element-selector">
            <nb-actions size="tiny">
                <nb-action>
                    <div class="title">Active Content: {{selectedContent?.name}}</div>
                </nb-action>
                <nb-action title="Edit Text"
                    class="popover-icon"
                    [nbPopover]="textPop"
                    [nbPopoverContext]="textPopContext">
                    <nb-icon icon="text-edit" pack="content-icons"></nb-icon>
                </nb-action>
                <nb-action title="Border"
                    class="popover-icon"
                    [nbPopover]="borderPop"
                    [nbPopoverContext]="borderPopContext">
                    <nb-icon icon="border" pack="content-icons"></nb-icon>
                </nb-action>
                <nb-action title="Padding"
                    class="popover-icon"
                    [nbPopover]="paddingPop"
                    [nbPopoverContext]="paddingPopContext">
                    <nb-icon icon="padding" pack="content-icons"></nb-icon>
                </nb-action>
                <nb-action title="Margin"
                    class="popover-icon"
                    [nbPopover]="textPop"
                    [nbPopoverContext]="textPopContext">
                    <nb-icon icon="margin" pack="content-icons"></nb-icon>
                </nb-action>
                <nb-action title="Align Left">
                    <nb-icon icon="align-left" pack="content-icons" (click)="setHorizontalAlign('justify-left')"></nb-icon>
                </nb-action>
                <nb-action title="Align Center">
                    <nb-icon icon="align-center" pack="content-icons" (click)="setHorizontalAlign('justify-center')"></nb-icon>
                </nb-action>
                <nb-action title="Align Right">
                    <nb-icon icon="align-right" pack="content-icons" (click)="setHorizontalAlign('justify-right')"></nb-icon>
                </nb-action>
                <nb-action title="Width" class="no-side-borders">
                    <nb-icon icon="width" pack="content-icons"> : </nb-icon>
                </nb-action>
                    <nb-action>
                        <div class="radio-group-wrapper">
                            <nb-radio-group [value]="selectedWidth" (valueChange)="onWidthChange($event)">
                                <nb-radio *ngFor="let option of widthOptions" [value]="option">{{option.name}}</nb-radio>
                            </nb-radio-group>
                        </div>
                    </nb-action>
                
            </nb-actions>
            <!-- <div class="element-values">
                <nb-actions size="tiny">
                    
                    <nb-action>Fill:</nb-action>
                    <nb-action title="Fill Color"
                        class="popover-icon"
                        [nbPopover]="component" 
                        [nbPopoverContext]="{color:textColor,colors:fillColors,content:selectedContent,target:'container',property:'background'}" nbPopoverPlacement="top">
                        <svg viewBox="0 0 24 24" id="ic_format_color_fill_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                            <path d="M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15a1.49 1.49 0 0 0 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z"/>
                            <path fill-opacity=".36" d="M0 20h24v4H0z" />
                        </svg>
                    </nb-action>
                </nb-actions>                
            </div>  -->       
        </div>
        <div class="element-selector">
            <nb-actions size="tiny">
                <nb-action>
                    <div class="title">Container Styles:</div>
                </nb-action>
                <nb-action title="Container Background"
                    class="popover-icon"
                    [nbPopover]="component"
                    [nbPopoverContext]="backgroundPopContext">
                    <nb-icon icon="background-color" pack="content-icons"></nb-icon>
                </nb-action>
                <nb-action title="Border"
                    class="popover-icon"
                    [nbPopover]="borderPop"
                    [nbPopoverContext]="parentBorderPopContext">
                    <nb-icon icon="border" pack="content-icons"></nb-icon>
                </nb-action>
                <nb-action title="Align top">
                    <nb-icon icon="align-top" pack="content-icons" (click)="setVerticalAlign('container-align-top')"></nb-icon>
                </nb-action>
                <nb-action title="Align Middle">
                    <nb-icon icon="align-middle" pack="content-icons" (click)="setVerticalAlign('container-align-middle')"></nb-icon>
                </nb-action>
                <nb-action title="Align Bottom">
                    <nb-icon icon="align-bottom" pack="content-icons" (click)="setVerticalAlign('container-align-bottom')"></nb-icon>
                </nb-action>
            </nb-actions>
        </div>
        <div class="element-selector">
            <nb-actions size="tiny">
                <nb-action>
                    <div class="title">Settings:</div>
                </nb-action>
                <nb-action title="Link"
                    class="popover-icon"
                    [nbPopover]="actionPop"
                    #popover="nbPopover"
                    nbPopoverTrigger="noop"
                    (click)="togglePopover(popover)" 
                    [nbPopoverContext]="{title:'Configure Action',service:'cellEditorStoreService',target:'content'}">
                    <nb-icon icon="link-2-outline" pack="eva"></nb-icon>
                </nb-action>
                <nb-action title="Visibility"
                    class="popover-icon"
                    [nbPopover]="actionPop" 
                    [nbPopoverContext]="{title:'Set Visibility',service:'cellEditorStoreService',target:'content'}">
                    <nb-icon icon="visibility" pack="content-icons"></nb-icon>
                </nb-action>
                
            </nb-actions>
        </div>
    </div>


